import React, { useState } from 'react';
import { Container, Grid, Dialog, Box } from '@mui/material';
import { useLoaderData } from 'react-router-dom';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import {
    AwardsSection,
    SectionTitle
} from '../styles/awards.styles';
import ParticleBackground from './ParticleBackground';
import CommonDialog from '../reusable-components/common-dialog';
import AwardCard from './AwardCard';
import { triggerConfetti } from '../utils/confetti';

const AwardsShowcase = () => {
    const { meInfo } = useLoaderData();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedAward, setSelectedAward] = useState(null);
    const [certificateOpen, setCertificateOpen] = useState(false);
    const [selectedCertificate, setSelectedCertificate] = useState(null);

    const handleReadMore = (award) => {
        setSelectedAward(award);
        setDialogOpen(true);
    };

    const handleClose = () => {
        setDialogOpen(false);
        setSelectedAward(null);
    };

    const handleViewCertificate = (award) => {
        setSelectedCertificate(award);
        setCertificateOpen(true);
        triggerConfetti();
    };

    const handleCloseCertificate = () => {
        setCertificateOpen(false);
        setSelectedCertificate(null);
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.2,
                duration: 0.5,
                ease: "easeOut"
            }
        }),
        hover: {
            scale: 1.05,
            rotateY: 5,
            rotateX: -5,
            transition: {
                duration: 0.3,
                ease: "easeOut"
            }
        }
    };

    return (
        <>
            <AwardsSection id="awards" component="section">
                <ParticleBackground />
                <Container>
                    <SectionTitle variant="h3" gutterBottom>
                        <EmojiEventsIcon sx={{ fontSize: '2.5rem' }} />
                        Awards & Recognition
                    </SectionTitle>
                    <Grid container spacing={4}>
                        {meInfo.awards.map((award, index) => (
                            <Grid item xs={12} md={4} key={index}>
                                <AwardCard 
                                    award={{...award, index, cardVariants}}
                                    onReadMore={handleReadMore}
                                    onViewCertificate={handleViewCertificate}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </AwardsSection>

            <CommonDialog
                open={dialogOpen}
                onClose={handleClose}
                title={selectedAward?.title}
                content={selectedAward?.description}
            />

            <Dialog 
                open={certificateOpen} 
                onClose={handleCloseCertificate} 
                maxWidth="md"
                fullWidth
                slotProps={{
                    transition: {
                        onEntered: () => {
                            triggerConfetti();
                        }
                    },
                    paper: {
                        sx: {
                            borderRadius: 2,
                            overflow: 'hidden',
                            backgroundColor: '#fff',
                            position: 'relative'
                        }
                    }
                }}
            >
                {selectedCertificate && (
                    <>
                        <Box
                            component="img"
                            src={selectedCertificate.certificateUrl}
                            alt={selectedCertificate.title}
                            sx={{
                                width: '100%',
                                display: 'block'
                            }}
                        />
                    </>
                )}
            </Dialog>
        </>
    );
};

export default AwardsShowcase; 